export default {
      id: "mission-register-usage",
      viewBox: "0 0 28 29",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#mission-register",
      toString: function () {
        return this.url;
      }
    }